import {Action, Module} from 'vuex-module-decorators';
import {LeagueApi} from '@/api/league.api';
import {take} from 'rxjs/operators';
import {UserModel} from '@/models/user.model';
import store from '@/store';
import {EntityStateAdapter} from '@/store/base.store';

export const featureKey = 'league';

// @ts-ignore
if (store.state.league) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class LeagueStoreModule extends EntityStateAdapter<UserModel> {

  @Action({commit: 'insertMany', rawError: true})
  fetchLeague(): Promise<UserModel[]> {
    return (new LeagueApi())
      .all()
      .pipe(take(1))
      .toPromise()
  }


  get league(): UserModel[] {
    return this._entities
  }
}
